const allImages = import.meta.glob('../**/*.webp', { import: 'default', eager: true })

export const useLoadImage = path => {
  const found = Object.keys(allImages).find(c => c.includes(path))

  if (found) {
    return found
  } else {
    return null
  }
}
